import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { loadBingoTiles } from "../../actions/cms";
// TODO: some of this couold come from the CMS
import winImage from "./img/winner-line.png";
import introImg from "./img/intro.png";
import logoImg from "./img/logo.png";
import audioOnImg from "./img/audio-on.png";
import audioOffImg from "./img/audio-off.png";
import iconClose from "./img/icon-close.png";
import iconFb from "./img/icon-fb.png";
import iconTw from "./img/icon-tw.png";
import bingoGif from "./img/bingo.gif";
import bgGame from "./img/bg-game.jpg";
import $ from "jquery";
import {
  playAudio,
  winParameters,
  stopAudio,
  updateWinLine,
  selectTilesFromCategories,
  setStepCss,
} from "./utils";
import { RootState } from "../../reducers";
import { BingoGameState, BingoConfigProps } from "../../types";
import { bingoIds } from "../../analyticsTags";

import "./scss/main.scss";
import FocusTrap from 'focus-trap-react'

const introMp3 = require("./audio/intro.mp3");
const revealMp3 = require("./audio/tile-reveal.mp3");
const tileMp3 = require("./audio/tile-select.mp3");
const winMp3 = require("./audio/win-v2.mp3");

interface BingoDispatchProps {
  loadTiles: () => {};
}

type ConnectedProps = BingoDispatchProps & BingoGameState;
type Props = BingoConfigProps & ConnectedProps;

// Game tiles should be editable in the CMS.
// Game background and talent image are updated less frequently, possibly yearly.
// Optional whether these components can be updated in CMS or require front end development.

enum GameState {
  INTRO,
  RESET,
  GAME_SCREEN,
  WINNER,
}

const openFb = () => {
  const currentUrl = window.location.origin + window.location.pathname;
  window.open(
    `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
    "facebook_share",
    "width=600, height=400"
  );
};

const openTw = () => {
  const currentUrl = window.location.origin + window.location.pathname;
  const twURL = "http://twitter.com/share?text=";
  const shareCopy =
    "WATCH AND PLAY! WHEEL BINGO. Use this Wheel Bingo board to play along while you watch Wheel!";
  window.open(
    `${twURL}${shareCopy}&url=${currentUrl}`,
    "twitter_share",
    "width=600, height=400"
  );
};

const Bingo: React.FC<Props> = ({
  loadTiles,
  isLoading,
  isLoaded,
  loadingError,
  freeSpace,
  tilesCategories,

  introLogo,
  iconVolOn,
  iconVolOff,
  headerLogo,
  winGraphic,
  winLine,
  backgroundImage,

  playBtnText,
  refreshBtnText: rfBtnText,
  howToPlayBtnText,

  boardBackgroundColor,
  boardBorderColor,
  tileHighlightColor,
  playBtnColor,
  refreshBtnColor,
  howToPlayBtnColor,
}) => {
  const introAudio = useRef<HTMLAudioElement>(null);
  const revealAudio = useRef<HTMLAudioElement>(null);
  const tileAudio = useRef<HTMLAudioElement>(null);
  const winAudio = useRef<HTMLAudioElement>(null);

  const [showModal, setShowModal] = React.useState(false)
  const [instructionsCss, setInstructionsCss] = useState("");
  const [boardCss, setBoardCss] = useState("");
  const [gameState, setGameState] = useState(GameState.INTRO);
  const [refreshBtnText, setRefreshBtnText] = useState(rfBtnText);
  const [tilesInPlay, setTilesInPlay] = useState<any[]>([]);
  const [clickedTiles, setClickedTiles] = useState<any>({});
  const [revealTiles, setRevealTiles] = useState(false);
  const [gameLineCss, setGameLineCss] = useState("");
  const [audioMuted, setAudioMuted] = useState(false); // TODO: get from cookie
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const init = useEffect(() => {
    loadTiles();
    playAudio(introAudio);
  }, [loadTiles]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const checkWin = useEffect(() => {
    const tileIDs = Object.keys(clickedTiles).map((id) => clickedTiles[id]);
    Object.keys(winParameters).forEach(function(direction) {
      Object.keys(winParameters[direction]).forEach(function(group) {
        let isWin = true;
        winParameters[direction][group].forEach(function(val: any) {
          if (tileIDs.indexOf(val) < 0) {
            isWin = false;
          }
        });
        if (isWin) {
          stopAudio(tileAudio);
          setGameState(GameState.WINNER);
          setRefreshBtnText("play again");
          setBoardCss("fade-in-element disabled");
          setGameLineCss(updateWinLine(group));
          playAudio(winAudio);
        }
      });
    });
  }, [clickedTiles]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const loadBoard = useEffect(() => {
    // Using an effect for loadBoard allows for the state to update first for resetBoard.
    // This acts as a listener for updates on the state triggered by a reset and is
    // necessary for the animations to take effect.
    if (gameState === GameState.RESET && freeSpace && tilesCategories.length) {
      setGameState(GameState.GAME_SCREEN);
      setRefreshBtnText(rfBtnText);
      setTilesInPlay(selectTilesFromCategories(freeSpace, tilesCategories));
      setTimeout(function() {
        // showBoard();
        setBoardCss("fade-in-element");
        playAudio(revealAudio);
        setRevealTiles(true);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gameState, freeSpace, tilesCategories]);

  const gameColor = "#ec008c";
  // backups in case api call data has falsy values
  // TODO: we could use placeholder assets instead to make it obvious that it needs data.
  introLogo = introLogo || introImg;
  iconVolOn = iconVolOn || audioOnImg;
  iconVolOff = iconVolOff || audioOffImg;
  headerLogo = headerLogo || logoImg;
  winGraphic = winGraphic || bingoGif;
  winLine = winLine || winImage;
  backgroundImage = backgroundImage || bgGame;
  playBtnText = playBtnText || "Play Now";
  rfBtnText = rfBtnText || "refresh";
  howToPlayBtnText = howToPlayBtnText || "How to play";
  boardBackgroundColor = boardBackgroundColor || "#d6d6d7";
  boardBorderColor = boardBorderColor || gameColor;
  tileHighlightColor = tileHighlightColor || "#E7078CCC";
  playBtnColor = playBtnColor || gameColor;
  refreshBtnColor = refreshBtnColor || gameColor;
  howToPlayBtnColor = howToPlayBtnColor || gameColor;

  // initListeners
  const showInstructions = () => {
    setTimeout(function() {
      $("#bingo_close_instructions").focus();
      setShowModal(true)
    }, 600);
    setInstructionsCss("fade-in-element");

  };

  const hideInstructions = () => {
    setTimeout(function() {
      $("#bingo_show_instructions").focus();
      setShowModal(false)
     }, 300);
    setInstructionsCss("fade-out-element");
    setInstructionsCss("");

  };

  const resetBoard = () => {
    setClickedTiles({});
    setTilesInPlay([]);
    setBoardCss("");
    setGameLineCss("");
    setRevealTiles(false);
    setGameState(GameState.RESET);
    setTimeout(function() {
      $("#bingo_show_instructions").focus();
    }, 600);
  };

  const handleTileClick = (tileId: any, i: number) => {
    if (clickedTiles[tileId]) {
      delete clickedTiles[tileId];
      setClickedTiles({ ...clickedTiles });
    } else {
      setClickedTiles({ [tileId]: i + 1, ...clickedTiles });
    }

    playAudio(tileAudio);
  };

  const toggleAudio = () => {
    setAudioMuted(!audioMuted);
  };
  // END: initListeners

  return (
  <>
   <style>{`
      .trap {
        position: absolute;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.5s, visibility 0.5s;
      }
      .trap.is-active {
        opacity: 1;
        visibility: visible;
      }
      `}</style>

    <div id="wof-bingo" style={{ backgroundImage: backgroundImage }}>
      <link
        href="https://fonts.googleapis.com/css?family=Lato:400,300,100,700"
        rel="stylesheet"
        type="text/css"
      />
      <audio muted={audioMuted} ref={introAudio} src={introMp3} />
      <audio muted={audioMuted} ref={revealAudio} src={revealMp3} />
      <audio muted={audioMuted} ref={tileAudio} src={tileMp3} />
      <audio muted={audioMuted} ref={winAudio} src={winMp3} />
      {/* intro */}
      <div
        id="intro-bingo"
        className={setStepCss(gameState === GameState.INTRO)}
      >
        <img id="intro-img" src={introLogo} alt="Wheel Bingo" />
        <button
          id={bingoIds.bingoPlayNow}
          onClick={resetBoard}
          style={{ backgroundColor: playBtnColor }}
          className="btn-game audio_btn bingo_play_now"
        >
          {isLoading ? "Loading..." : playBtnText}
        </button>
      </div>
      {/* END intro */}
      <div
        id="game-screen"
        className={setStepCss(
          gameState === GameState.WINNER || gameState === GameState.GAME_SCREEN,
          gameState === GameState.WINNER ? "disabled" : ""
        )}
      >
        <div id="game-top-bar">
          <div id="game-top-bar-container">
            <div id="game-logo" className="game-top-bar-content">
              <img src={headerLogo} alt="WOF Bingo" title="WOF Bingo" />
            </div>
            <button
              role="dialog"
              aria-expanded="true"
              id={bingoIds.bingoShowInstructions}
              onClick={showInstructions}
              style={{ backgroundColor: howToPlayBtnColor }}
            >
              <h3>{howToPlayBtnText}</h3>
            </button>
            <button
              role="button"
              aria-label="audio"
              id={bingoIds.bingoVolumeToggle}
              className="game-top-bar-content"
              onClick={toggleAudio}
            >
              {audioMuted ? (
                <img id="volume_off" src={iconVolOff} alt="Audio Off" />
              ) : (
                <img id="volume_on" src={iconVolOn} alt="Audio On" />
              )}
            </button>
          </div>
        </div>
        {/* END game-top-bar */}
        <div className="game-board-wrapper">
          <div
            tabIndex={0}
            id="game-board"
            className={boardCss}
            style={{
              backgroundColor: boardBackgroundColor,
              borderColor: boardBorderColor,
            }}
          >
            <div id="game-letters">
              <div className="game-letter">B</div>
              <div className="game-letter">I</div>
              <div className="game-letter">N</div>
              <div className="game-letter">G</div>
              <div className="game-letter">O</div>
            </div>
            <div id="game-tiles">
              {tilesInPlay.length > 0 && (
                <div id="game-winner-line" className={gameLineCss}>
                  <img src={winLine} alt="winner" />
                </div>
              )}
              {tilesInPlay.map((tile, i) => (
                <button
                  id={bingoIds.computed.bingoTile(tile.id)}
                  key={`tile_${i}`}
                  className={`${tile.id} ${
                    revealTiles ? "fade-in-expand-element" : ""
                  } game-tile`}
                  style={{
                    color: tileHighlightColor,
                    backgroundImage: `url(${tile.img})`,
                    animationDelay: `${100 * (i + 1)}ms`,
                  }}
                  onClick={() => handleTileClick(tile.id, i)}
                >
                  <div
                    className={tile.id in clickedTiles ? "mark-tile" : ""}
                    style={{ color: tileHighlightColor }}
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
        {/* END game-board */}

        <div
          id="winner"
          className={setStepCss(
            gameState === GameState.WINNER,
            gameState === GameState.WINNER ? "fade-in-expand-element" : ""
          )}
        >
          <img src={winGraphic} alt="Bingo" title="Bingo" />
        </div>
        {/* END winner */}
        <div id="instructions" className={instructionsCss}>
          <div id="instructions-container" role="dialog" aria-label="Wheel Bingo Instructions">
            <FocusTrap active={showModal} >
              <div tabIndex={0}>
              <button
                id={bingoIds.bingoCloseInstructions}
                onClick={hideInstructions}
              >
                <img
                  className="bingo_close_instructions-content"
                  src={iconClose}
                  alt="Close"
                  title="Close"
                />
                <h4  className="bingo_close_instructions-content">Close</h4>
              </button>
              </div>
            </FocusTrap>
            <h3>Wheel Bingo is fun and easy to play:</h3>
            <ul>
              <li>
                Look for the pictures on your board to come into play during the
                show.
              </li>
              <li>Mark the corresponding space on your board if:</li>
              <li className="indent">
                A letter on your board appears in the puzzle
              </li>
              <li className="indent">
                A contestant lands on a wedge that is on your board and guesses
                correctly (e.g., calls a letter in the puzzle)
              </li>
              <li className="indent">
                A contestant lands on Bankrupt or Lose a Turn
              </li>
              <li className="indent">Ryan spins or Vanna claps: lucky you!</li>
              <li>Mark five in a row across, down or diagonally to win.</li>
              <li>Hit REFRESH to play again with a new board.</li>
              <li>Play by yourself or with family and friends!</li>
            </ul>
          </div>
          {/* END instructions-container */}
        </div>
        {/* END instructions */}
        <button
          className="btn-game"
          style={{ backgroundColor: refreshBtnColor }}
          id={bingoIds.bingoPlayNow}
          onClick={resetBoard}
        >
          {refreshBtnText}
        </button>
        {/* END btn-refresh */}
        <div id="social-icons">
          <button onClick={openFb}>
            <img
              id={bingoIds.bingoFacebookShare}
              className="social-icon"
              src={iconFb}
              alt="Facebook"
              title="Facebook"
            />
          </button>
          <button onClick={openTw}>
            <img
              id={bingoIds.bingoTwitterShare}
              className="social-icon"
              src={iconTw}
              alt="Twitter"
              title="Twitter"
            />
          </button>
        </div>
        {/* END social-icons */}
      </div>
      {/* END game-screen */}
    </div>
  </>
  );
};

const mapStateToProps = (state: RootState) => ({
  ...(state.bingo as ConnectedProps),
});
const mapDispatchToProps = (dispatch: any) => ({
  loadTiles: () => dispatch(loadBingoTiles()),
});

export { Bingo };

const ConnectedBingo = connect(mapStateToProps, mapDispatchToProps)(Bingo);

export default ConnectedBingo;
